import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _004d2fbc = () => interopDefault(import('../../../pages/errors/index.vue' /* webpackChunkName: "pages/errors/index" */))
const _de7828be = () => interopDefault(import('../../../pages/sample/index.vue' /* webpackChunkName: "pages/sample/index" */))
const _1e7c8d87 = () => interopDefault(import('../../../pages/errors/errorPage.vue' /* webpackChunkName: "pages/errors/errorPage" */))
const _3461de7e = () => interopDefault(import('../../../pages/errors/notFoundPage.vue' /* webpackChunkName: "pages/errors/notFoundPage" */))
const _132e9f2a = () => interopDefault(import('../../../pages/portal/search/index.vue' /* webpackChunkName: "pages/portal/search/index" */))
const _b1b081ae = () => interopDefault(import('../../../pages/portal/youtubeTest/index.vue' /* webpackChunkName: "pages/portal/youtubeTest/index" */))
const _65301182 = () => interopDefault(import('../../../pages/sample/calendar/index.vue' /* webpackChunkName: "pages/sample/calendar/index" */))
const _0d5495b8 = () => interopDefault(import('../../../pages/sample/carousel/index.vue' /* webpackChunkName: "pages/sample/carousel/index" */))
const _f95703b2 = () => interopDefault(import('../../../pages/sample/github/index.vue' /* webpackChunkName: "pages/sample/github/index" */))
const _3f30bf2c = () => interopDefault(import('../../../pages/sample/rxjs_sample/index.vue' /* webpackChunkName: "pages/sample/rxjs_sample/index" */))
const _53670fe0 = () => interopDefault(import('../../../pages/portal/GwNoteDataBoxGuide/GwNoteDataBoxGuide.vue' /* webpackChunkName: "pages/portal/GwNoteDataBoxGuide/GwNoteDataBoxGuide" */))
const _ed6b93d0 = () => interopDefault(import('../../../pages/portal/joinGuide/ipCertifiedGuide.vue' /* webpackChunkName: "pages/portal/joinGuide/ipCertifiedGuide" */))
const _2b69e852 = () => interopDefault(import('../../../pages/portal/joinGuide/phoneCertifiedGuide.vue' /* webpackChunkName: "pages/portal/joinGuide/phoneCertifiedGuide" */))
const _76a56db9 = () => interopDefault(import('../../../pages/portal/mam/mam_list.vue' /* webpackChunkName: "pages/portal/mam/mam_list" */))
const _6db79c40 = () => interopDefault(import('../../../pages/portal/mam/mam_view.vue' /* webpackChunkName: "pages/portal/mam/mam_view" */))
const _5ab77ed7 = () => interopDefault(import('../../../pages/portal/popupImg/popup_img.vue' /* webpackChunkName: "pages/portal/popupImg/popup_img" */))
const _74cc79f4 = () => interopDefault(import('../../../pages/portal/snsLogin/portal_sns.vue' /* webpackChunkName: "pages/portal/snsLogin/portal_sns" */))
const _2955b3bc = () => interopDefault(import('../../../pages/portal/ssoLogin/portal_sso.vue' /* webpackChunkName: "pages/portal/ssoLogin/portal_sso" */))
const _b04f9b20 = () => interopDefault(import('../../../pages/portal/ssoLogin/portal_sso_eow.vue' /* webpackChunkName: "pages/portal/ssoLogin/portal_sso_eow" */))
const _7ceff1c2 = () => interopDefault(import('../../../pages/sample/calendar/DateListModel.js' /* webpackChunkName: "pages/sample/calendar/DateListModel" */))
const _6dbf93f8 = () => interopDefault(import('../../../pages/sample/calendar/DateModel.js' /* webpackChunkName: "pages/sample/calendar/DateModel" */))
const _1c386a8a = () => interopDefault(import('../../../pages/sample/calendar/temp.js' /* webpackChunkName: "pages/sample/calendar/temp" */))
const _221535de = () => interopDefault(import('../../../pages/sample/gDrive/googleDriveUploadSample.vue' /* webpackChunkName: "pages/sample/gDrive/googleDriveUploadSample" */))
const _e3d3ad50 = () => interopDefault(import('../../../pages/sample/google/callGoogleApiSample.vue' /* webpackChunkName: "pages/sample/google/callGoogleApiSample" */))
const _01bfb2c8 = () => interopDefault(import('../../../pages/portal/manager/iframeMgmt/managerIframe.vue' /* webpackChunkName: "pages/portal/manager/iframeMgmt/managerIframe" */))
const _774f048b = () => interopDefault(import('../../../pages/portal/manager/layout/TheManagerFooter.vue' /* webpackChunkName: "pages/portal/manager/layout/TheManagerFooter" */))
const _7e74a0fc = () => interopDefault(import('../../../pages/portal/manager/layout/TheManagerSideBar.vue' /* webpackChunkName: "pages/portal/manager/layout/TheManagerSideBar" */))
const _de785126 = () => interopDefault(import('../../../pages/portal/user/common/commonBoard_edit.vue' /* webpackChunkName: "pages/portal/user/common/commonBoard_edit" */))
const _fd089ffe = () => interopDefault(import('../../../pages/portal/user/common/commonBoard_list.vue' /* webpackChunkName: "pages/portal/user/common/commonBoard_list" */))
const _788dde88 = () => interopDefault(import('../../../pages/portal/user/common/commonBoard_view.vue' /* webpackChunkName: "pages/portal/user/common/commonBoard_view" */))
const _0f0bb96e = () => interopDefault(import('../../../pages/portal/user/common/commonForm.vue' /* webpackChunkName: "pages/portal/user/common/commonForm" */))
const _b4bec6d4 = () => interopDefault(import('../../../pages/portal/user/common/commonScreen.vue' /* webpackChunkName: "pages/portal/user/common/commonScreen" */))
const _21222197 = () => interopDefault(import('../../../pages/portal/user/eduTech/edu_tech.vue' /* webpackChunkName: "pages/portal/user/eduTech/edu_tech" */))
const _7c5cfe0d = () => interopDefault(import('../../../pages/portal/user/join/join_auth.vue' /* webpackChunkName: "pages/portal/user/join/join_auth" */))
const _0a3b9e42 = () => interopDefault(import('../../../pages/portal/user/join/join_certificate.vue' /* webpackChunkName: "pages/portal/user/join/join_certificate" */))
const _267db59e = () => interopDefault(import('../../../pages/portal/user/join/join_main.vue' /* webpackChunkName: "pages/portal/user/join/join_main" */))
const _c31f644e = () => interopDefault(import('../../../pages/portal/user/join/join_proxy.vue' /* webpackChunkName: "pages/portal/user/join/join_proxy" */))
const _66fcbaca = () => interopDefault(import('../../../pages/portal/user/join/join_write.vue' /* webpackChunkName: "pages/portal/user/join/join_write" */))
const _58b4e0ad = () => interopDefault(import('../../../pages/portal/user/join/joinSupporter.js' /* webpackChunkName: "pages/portal/user/join/joinSupporter" */))
const _e48c1f20 = () => interopDefault(import('../../../pages/portal/user/landing/user_landing.vue' /* webpackChunkName: "pages/portal/user/landing/user_landing" */))
const _73cbbea0 = () => interopDefault(import('../../../pages/portal/user/login/user_login.vue' /* webpackChunkName: "pages/portal/user/login/user_login" */))
const _3791fe56 = () => interopDefault(import('../../../pages/portal/user/login/user_pwd_edit.vue' /* webpackChunkName: "pages/portal/user/login/user_pwd_edit" */))
const _c6eb5f4e = () => interopDefault(import('../../../pages/portal/user/login/user_search_id.vue' /* webpackChunkName: "pages/portal/user/login/user_search_id" */))
const _acf00976 = () => interopDefault(import('../../../pages/portal/user/login/user_search_pw.vue' /* webpackChunkName: "pages/portal/user/login/user_search_pw" */))
const _3237e328 = () => interopDefault(import('../../../pages/portal/user/main/user_main.vue' /* webpackChunkName: "pages/portal/user/main/user_main" */))
const _0099edd4 = () => interopDefault(import('../../../pages/portal/user/main/user_main_old.vue' /* webpackChunkName: "pages/portal/user/main/user_main_old" */))
const _14952f14 = () => interopDefault(import('../../../pages/portal/user/main/user_main2.vue' /* webpackChunkName: "pages/portal/user/main/user_main2" */))
const _0444d3c4 = () => interopDefault(import('../../../pages/portal/user/search/search_main.vue' /* webpackChunkName: "pages/portal/user/search/search_main" */))
const _c1c2a392 = () => interopDefault(import('../../../pages/portal/user/sso/sso_account_mgnt.vue' /* webpackChunkName: "pages/portal/user/sso/sso_account_mgnt" */))
const _2d478c03 = () => interopDefault(import('../../../pages/portal/user/sso/sso_login_eox.vue' /* webpackChunkName: "pages/portal/user/sso/sso_login_eox" */))
const _00d302d8 = () => interopDefault(import('../../../pages/portal/user/userWorkspace/manageMy_information.vue' /* webpackChunkName: "pages/portal/user/userWorkspace/manageMy_information" */))
const _14506f68 = () => interopDefault(import('../../../pages/portal/user/userWorkspace/part_edit.vue' /* webpackChunkName: "pages/portal/user/userWorkspace/part_edit" */))
const _9410039a = () => interopDefault(import('../../../pages/portal/user/userWorkspace/userMgmt_edit.vue' /* webpackChunkName: "pages/portal/user/userWorkspace/userMgmt_edit" */))
const _b2a05272 = () => interopDefault(import('../../../pages/portal/user/userWorkspace/userMgmt_list.vue' /* webpackChunkName: "pages/portal/user/userWorkspace/userMgmt_list" */))
const _393ffdb4 = () => interopDefault(import('../../../pages/portal/workspace/main/main.vue' /* webpackChunkName: "pages/portal/workspace/main/main" */))
const _ef4a401a = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/history/history_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/history/history_list" */))
const _d310cfa0 = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/mainTask/main_task_edit.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/mainTask/main_task_edit" */))
const _f1a11e78 = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/mainTask/main_task_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/mainTask/main_task_list" */))
const _6874095a = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/managerSchedule/managerSchedule_board_view.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/managerSchedule/managerSchedule_board_view" */))
const _76993153 = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/managerSchedule/managerSchedule_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/managerSchedule/managerSchedule_list" */))
const _30d7d29d = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/orgChart/orgChart_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/orgChart/orgChart_list" */))
const _6152656f = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/popup/popup_edit.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/popup/popup_edit" */))
const _520a3e03 = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/popup/popup_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/popup/popup_list" */))
const _19ba8375 = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/youtube/youTube_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/youtube/youTube_list" */))
const _a044b8d0 = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/youtube/youTube_upload.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/youtube/youTube_upload" */))
const _2a71e4aa = () => interopDefault(import('../../../pages/portal/manager/mamMgmt/appMgmt/app_edit.vue' /* webpackChunkName: "pages/portal/manager/mamMgmt/appMgmt/app_edit" */))
const _49023382 = () => interopDefault(import('../../../pages/portal/manager/mamMgmt/appMgmt/app_list.vue' /* webpackChunkName: "pages/portal/manager/mamMgmt/appMgmt/app_list" */))
const _175cf1de = () => interopDefault(import('../../../pages/portal/manager/mamMgmt/domainMgmt/domain_edit.vue' /* webpackChunkName: "pages/portal/manager/mamMgmt/domainMgmt/domain_edit" */))
const _35ed40b6 = () => interopDefault(import('../../../pages/portal/manager/mamMgmt/domainMgmt/domain_list.vue' /* webpackChunkName: "pages/portal/manager/mamMgmt/domainMgmt/domain_list" */))
const _6c1ecc66 = () => interopDefault(import('../../../pages/portal/manager/onlinerequestMgmt/bulletinMgmt/bulletinMgmt_edit.vue' /* webpackChunkName: "pages/portal/manager/onlinerequestMgmt/bulletinMgmt/bulletinMgmt_edit" */))
const _8aaf1b3e = () => interopDefault(import('../../../pages/portal/manager/onlinerequestMgmt/bulletinMgmt/bulletinMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/onlinerequestMgmt/bulletinMgmt/bulletinMgmt_list" */))
const _10168bbe = () => interopDefault(import('../../../pages/portal/manager/onlinerequestMgmt/statisticsMgmt/statisticsMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/onlinerequestMgmt/statisticsMgmt/statisticsMgmt_list" */))
const _ab2ffdaa = () => interopDefault(import('../../../pages/portal/manager/onlinerequestMgmt/topicMgmt/topicMgmt_edit.vue' /* webpackChunkName: "pages/portal/manager/onlinerequestMgmt/topicMgmt/topicMgmt_edit" */))
const _c9c04c82 = () => interopDefault(import('../../../pages/portal/manager/onlinerequestMgmt/topicMgmt/topicMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/onlinerequestMgmt/topicMgmt/topicMgmt_list" */))
const _5fcb978a = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/bannedWords/bannedWordsMgmt.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/bannedWords/bannedWordsMgmt" */))
const _71dffed2 = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/manageDomainBlocking/manageDomainBlocking_edit.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/manageDomainBlocking/manageDomainBlocking_edit" */))
const _90704daa = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/manageDomainBlocking/manageDomainBlocking_list.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/manageDomainBlocking/manageDomainBlocking_list" */))
const _73062e2b = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/notice/notice_list.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/notice/notice_list" */))
const _5d3ed3dd = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/openUrlMgmt/openUrlMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/openUrlMgmt/openUrlMgmt_list" */))
const _fb1d4b56 = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/urlCreationStatus/urlCreationStatus_edit.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/urlCreationStatus/urlCreationStatus_edit" */))
const _732932e9 = () => interopDefault(import('../../../pages/portal/manager/shorteningUrlMgmt/urlCreationStatus/urlCreationStatus_list.vue' /* webpackChunkName: "pages/portal/manager/shorteningUrlMgmt/urlCreationStatus/urlCreationStatus_list" */))
const _17d77a10 = () => interopDefault(import('../../../pages/portal/user/adminActivate/bidInfo/bidInfo_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/bidInfo/bidInfo_list" */))
const _29b31d02 = () => interopDefault(import('../../../pages/portal/user/adminActivate/bidInfo/bidInfo_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/bidInfo/bidInfo_view" */))
const _daa295e0 = () => interopDefault(import('../../../pages/portal/user/adminActivate/notice/notice_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/notice/notice_list" */))
const _ec7e38d2 = () => interopDefault(import('../../../pages/portal/user/adminActivate/notice/notice_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/notice/notice_view" */))
const _2be4a0cc = () => interopDefault(import('../../../pages/portal/user/adminActivate/openBudget/budget_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/openBudget/budget_list" */))
const _3dc043be = () => interopDefault(import('../../../pages/portal/user/adminActivate/openBudget/budget_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/openBudget/budget_view" */))
const _414997fa = () => interopDefault(import('../../../pages/portal/user/adminActivate/openWorkcost/workcost_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/openWorkcost/workcost_list" */))
const _385bc681 = () => interopDefault(import('../../../pages/portal/user/adminActivate/openWorkcost/workcost_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/openWorkcost/workcost_view" */))
const _78910970 = () => interopDefault(import('../../../pages/portal/user/adminActivate/publicData/publicData_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/publicData/publicData_list" */))
const _6fa337f7 = () => interopDefault(import('../../../pages/portal/user/adminActivate/publicData/publicData_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/publicData/publicData_view" */))
const _243453b0 = () => interopDefault(import('../../../pages/portal/user/adminActivate/reportCenter/reportCenter_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/reportCenter/reportCenter_list" */))
const _1b468237 = () => interopDefault(import('../../../pages/portal/user/adminActivate/reportCenter/reportCenter_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/reportCenter/reportCenter_view" */))
const _55ea65e5 = () => interopDefault(import('../../../pages/portal/user/adminActivate/schedule/userSchedule_board_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/schedule/userSchedule_board_view" */))
const _17f4ce5e = () => interopDefault(import('../../../pages/portal/user/adminActivate/schedule/userSchedule_edit.vue' /* webpackChunkName: "pages/portal/user/adminActivate/schedule/userSchedule_edit" */))
const _36851d36 = () => interopDefault(import('../../../pages/portal/user/adminActivate/schedule/userSchedule_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/schedule/userSchedule_list" */))
const _155d1ee6 = () => interopDefault(import('../../../pages/portal/user/centerGuide/basicDirection/basic_direction.vue' /* webpackChunkName: "pages/portal/user/centerGuide/basicDirection/basic_direction" */))
const _88eb6da8 = () => interopDefault(import('../../../pages/portal/user/centerGuide/centerNews/news_edit.vue' /* webpackChunkName: "pages/portal/user/centerGuide/centerNews/news_edit" */))
const _a77bbc80 = () => interopDefault(import('../../../pages/portal/user/centerGuide/centerNews/news_list.vue' /* webpackChunkName: "pages/portal/user/centerGuide/centerNews/news_list" */))
const _b9575f72 = () => interopDefault(import('../../../pages/portal/user/centerGuide/centerNews/news_view.vue' /* webpackChunkName: "pages/portal/user/centerGuide/centerNews/news_view" */))
const _0c4a0d80 = () => interopDefault(import('../../../pages/portal/user/centerGuide/directions/center_directions.vue' /* webpackChunkName: "pages/portal/user/centerGuide/directions/center_directions" */))
const _1320a14a = () => interopDefault(import('../../../pages/portal/user/centerGuide/facility/facility_info.vue' /* webpackChunkName: "pages/portal/user/centerGuide/facility/facility_info" */))
const _9502949a = () => interopDefault(import('../../../pages/portal/user/centerGuide/greeting/director_greeting.vue' /* webpackChunkName: "pages/portal/user/centerGuide/greeting/director_greeting" */))
const _5cb4a8d5 = () => interopDefault(import('../../../pages/portal/user/centerGuide/history/history_status.vue' /* webpackChunkName: "pages/portal/user/centerGuide/history/history_status" */))
const _468bdbd7 = () => interopDefault(import('../../../pages/portal/user/centerGuide/mainTask/main_task.vue' /* webpackChunkName: "pages/portal/user/centerGuide/mainTask/main_task" */))
const _08462ded = () => interopDefault(import('../../../pages/portal/user/centerGuide/operationDirection/operation_direction.vue' /* webpackChunkName: "pages/portal/user/centerGuide/operationDirection/operation_direction" */))
const _defcb34a = () => interopDefault(import('../../../pages/portal/user/centerGuide/organization/organization_info.vue' /* webpackChunkName: "pages/portal/user/centerGuide/organization/organization_info" */))
const _1536e3b0 = () => interopDefault(import('../../../pages/portal/user/customerService/browser/browserGuide.vue' /* webpackChunkName: "pages/portal/user/customerService/browser/browserGuide" */))
const _39550c06 = () => interopDefault(import('../../../pages/portal/user/customerService/copyright/copyrightProtect.vue' /* webpackChunkName: "pages/portal/user/customerService/copyright/copyrightProtect" */))
const _4f085b6e = () => interopDefault(import('../../../pages/portal/user/customerService/email/refusalOfEmail.vue' /* webpackChunkName: "pages/portal/user/customerService/email/refusalOfEmail" */))
const _08da1c23 = () => interopDefault(import('../../../pages/portal/user/eduResearch/contest/contest_edit.vue' /* webpackChunkName: "pages/portal/user/eduResearch/contest/contest_edit" */))
const _0cdc1692 = () => interopDefault(import('../../../pages/portal/user/eduResearch/contest/contest_list.vue' /* webpackChunkName: "pages/portal/user/eduResearch/contest/contest_list" */))
const _1eb7b984 = () => interopDefault(import('../../../pages/portal/user/eduResearch/contest/contest_view.vue' /* webpackChunkName: "pages/portal/user/eduResearch/contest/contest_view" */))
const _508d7301 = () => interopDefault(import('../../../pages/portal/user/eduResearch/dataroom/dataroom_list.vue' /* webpackChunkName: "pages/portal/user/eduResearch/dataroom/dataroom_list" */))
const _479fa188 = () => interopDefault(import('../../../pages/portal/user/eduResearch/dataroom/dataroom_view.vue' /* webpackChunkName: "pages/portal/user/eduResearch/dataroom/dataroom_view" */))
const _9744172c = () => interopDefault(import('../../../pages/portal/user/eduResearch/notice/research_edit.vue' /* webpackChunkName: "pages/portal/user/eduResearch/notice/research_edit" */))
const _b5d46604 = () => interopDefault(import('../../../pages/portal/user/eduResearch/notice/research_list.vue' /* webpackChunkName: "pages/portal/user/eduResearch/notice/research_list" */))
const _c7b008f6 = () => interopDefault(import('../../../pages/portal/user/eduResearch/notice/research_view.vue' /* webpackChunkName: "pages/portal/user/eduResearch/notice/research_view" */))
const _1c54ebf5 = () => interopDefault(import('../../../pages/portal/user/eduResearch/school/edu_school.vue' /* webpackChunkName: "pages/portal/user/eduResearch/school/edu_school" */))
const _662203b2 = () => interopDefault(import('../../../pages/portal/user/myPage/accessHistory/accessHistory_edit.vue' /* webpackChunkName: "pages/portal/user/myPage/accessHistory/accessHistory_edit" */))
const _69e89e2e = () => interopDefault(import('../../../pages/portal/user/myPage/changePassword/changePassword_edit.vue' /* webpackChunkName: "pages/portal/user/myPage/changePassword/changePassword_edit" */))
const _1c9a6da8 = () => interopDefault(import('../../../pages/portal/user/myPage/mobile/mobile_myPageInfo.vue' /* webpackChunkName: "pages/portal/user/myPage/mobile/mobile_myPageInfo" */))
const _f108d2ee = () => interopDefault(import('../../../pages/portal/user/myPage/personalInfo/personalInfo_edit.vue' /* webpackChunkName: "pages/portal/user/myPage/personalInfo/personalInfo_edit" */))
const _1835d80a = () => interopDefault(import('../../../pages/portal/user/myPage/snsInfo/snsInfo_edit.vue' /* webpackChunkName: "pages/portal/user/myPage/snsInfo/snsInfo_edit" */))
const _35869fae = () => interopDefault(import('../../../pages/portal/user/myPage/withdrawal/withdrawal_edit.vue' /* webpackChunkName: "pages/portal/user/myPage/withdrawal/withdrawal_edit" */))
const _11da26a8 = () => interopDefault(import('../../../pages/portal/user/openInfo/infoList/infoList_edit.vue' /* webpackChunkName: "pages/portal/user/openInfo/infoList/infoList_edit" */))
const _306a7580 = () => interopDefault(import('../../../pages/portal/user/openInfo/infoList/infoList_list.vue' /* webpackChunkName: "pages/portal/user/openInfo/infoList/infoList_list" */))
const _42461872 = () => interopDefault(import('../../../pages/portal/user/openInfo/infoList/infoList_view.vue' /* webpackChunkName: "pages/portal/user/openInfo/infoList/infoList_view" */))
const _17c3b2f0 = () => interopDefault(import('../../../pages/portal/user/openInfo/preInfo/preInfo_edit.vue' /* webpackChunkName: "pages/portal/user/openInfo/preInfo/preInfo_edit" */))
const _365401c8 = () => interopDefault(import('../../../pages/portal/user/openInfo/preInfo/preInfo_list.vue' /* webpackChunkName: "pages/portal/user/openInfo/preInfo/preInfo_list" */))
const _482fa4ba = () => interopDefault(import('../../../pages/portal/user/openInfo/preInfo/preInfo_view.vue' /* webpackChunkName: "pages/portal/user/openInfo/preInfo/preInfo_view" */))
const _6645370e = () => interopDefault(import('../../../pages/portal/user/sendSms/sendSmsPage/sendSmsPage.vue' /* webpackChunkName: "pages/portal/user/sendSms/sendSmsPage/sendSmsPage" */))
const _f255b54a = () => interopDefault(import('../../../pages/portal/manager/homepageMgmt/statistics/tchecked/tchecked_list.vue' /* webpackChunkName: "pages/portal/manager/homepageMgmt/statistics/tchecked/tchecked_list" */))
const _14e1952b = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/bannedWordsMgmt/bannedWordsMgmt_CommonList.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/bannedWordsMgmt/bannedWordsMgmt_CommonList" */))
const _85281500 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/bannedWordsMgmt/bannedWordsMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/bannedWordsMgmt/bannedWordsMgmt_list" */))
const _ea1de46c = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/boardMgmt/boardMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/boardMgmt/boardMgmt_list" */))
const _875f8bb2 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/boardMgmt/boardMgmt_posting_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/boardMgmt/boardMgmt_posting_list" */))
const _6d9fee1a = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/deletedPostingMgmt/deletedPostingMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/deletedPostingMgmt/deletedPostingMgmt_list" */))
const _4781ca77 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/deletedPostingMgmt/deletedPostingMgmt_posting_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/deletedPostingMgmt/deletedPostingMgmt_posting_list" */))
const _c0d41504 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/postingMgmt/postingMgmt_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/postingMgmt/postingMgmt_edit" */))
const _df6463dc = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/integratedBoardMgmt/postingMgmt/postingMgmt_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/integratedBoardMgmt/postingMgmt/postingMgmt_list" */))
const _1559a005 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/block/block_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/block/block_list" */))
const _346fbbdd = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/dormant/dormant_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/dormant/dormant_list" */))
const _15eea87b = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/general/general_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/general/general_edit" */))
const _06a6810f = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/general/general_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/general/general_list" */))
const _48327ab2 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/memberIp/ip_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/memberIp/ip_edit" */))
const _66c2c98a = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/memberIp/ip_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/memberIp/ip_list" */))
const _8f2f3a6e = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/permission/permission_classification.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/permission/permission_classification" */))
const _110931b7 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/secession/secession_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/secession/secession_list" */))
const _818f306a = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/staff/staff_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/staff/staff_edit" */))
const _a01f7f42 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/memberMgmt/staff/staff_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/memberMgmt/staff/staff_list" */))
const _44adc5f8 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/menuMgmt/menu/menu_Classification.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/menuMgmt/menu/menu_Classification" */))
const _ebd8ec0e = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/sendSmsMgmt/autoSendMail/mailTemplate_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/sendSmsMgmt/autoSendMail/mailTemplate_list" */))
const _733692d2 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/sendSmsMgmt/autoSendSms/autoSendSms.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/sendSmsMgmt/autoSendSms/autoSendSms" */))
const _05305612 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/sendSmsMgmt/hist/sendHistList.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/sendSmsMgmt/hist/sendHistList" */))
const _1f5332dc = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/sendSmsMgmt/sendMailHist/sendMailHist_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/sendSmsMgmt/sendMailHist/sendMailHist_list" */))
const _38258d5a = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/sendSmsMgmt/sendSmsPage/sendSmsPage.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/sendSmsMgmt/sendSmsPage/sendSmsPage" */))
const _3df66117 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/agencyCode/agency_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/agencyCode/agency_edit" */))
const _2eae39ab = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/agencyCode/agency_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/agencyCode/agency_list" */))
const _6754b4d7 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/commonCode/common_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/commonCode/common_edit" */))
const _580c8d6b = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/commonCode/common_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/commonCode/common_list" */))
const _1a283038 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/envConfig/env_config.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/envConfig/env_config" */))
const _297a495e = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/modutalk/modutalk_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/modutalk/modutalk_list" */))
const _59e5336f = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/unassignedAgency/unassigned_agency_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/unassignedAgency/unassigned_agency_edit" */))
const _4a9d0c03 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/standardInformationMgmt/unassignedAgency/unassigned_agency_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/standardInformationMgmt/unassignedAgency/unassigned_agency_list" */))
const _36aad106 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_detail.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_detail" */))
const _556ba57f = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_edit" */))
const _46237e13 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_list" */))
const _df0f2cfe = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_detail.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_detail" */))
const _bda9be8c = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_edit" */))
const _dc3a0d64 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_list" */))
const _2218427e = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_detail.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_detail" */))
const _12fa340c = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_edit.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_edit" */))
const _318a82e4 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_list" */))
const _43d28ee8 = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/menuAccessStatistics/accessStatus_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/menuAccessStatistics/accessStatus_list" */))
const _90e0e56a = () => interopDefault(import('../../../pages/portal/manager/portalMgmt/statisticsMgmt/systemVisitStatus/visitStatus_list.vue' /* webpackChunkName: "pages/portal/manager/portalMgmt/statisticsMgmt/systemVisitStatus/visitStatus_list" */))
const _77094dca = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/auditGoogleUser/audit_google_user_list.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/auditGoogleUser/audit_google_user_list" */))
const _5f2890fa = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/deleteAccount/delete_list.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/deleteAccount/delete_list" */))
const _8d630ffe = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/user_account.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/user_account" */))
const _57c6c2d9 = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/user_account_delete.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/user_account_delete" */))
const _11e9e812 = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/organizationMgmt/authorityMgmt/authority.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/organizationMgmt/authorityMgmt/authority" */))
const _174a7440 = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/organizationMgmt/schoolMgmt/school_list.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/organizationMgmt/schoolMgmt/school_list" */))
const _631671c6 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/genAffairs/genAffairs_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/genAffairs/genAffairs_list" */))
const _5a28a04d = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/genAffairs/genAffairs_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/genAffairs/genAffairs_view" */))
const _9b8e7690 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/gwEdu/gwEdu_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/gwEdu/gwEdu_list" */))
const _ad6a1982 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/gwEdu/gwEdu_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/gwEdu/gwEdu_view" */))
const _35a88a02 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/infoSupport/infoSupport_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/infoSupport/infoSupport_list" */))
const _2cbab889 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/infoSupport/infoSupport_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/infoSupport/infoSupport_view" */))
const _077698c6 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/scienceEdu/scienceEdu_list.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/scienceEdu/scienceEdu_list" */))
const _02ee7166 = () => interopDefault(import('../../../pages/portal/user/adminActivate/dataroom/scienceEdu/scienceEdu_view.vue' /* webpackChunkName: "pages/portal/user/adminActivate/dataroom/scienceEdu/scienceEdu_view" */))
const _2d86983c = () => interopDefault(import('../../../pages/portal/user/customerService/privatePolicy/operationalPolicy/operationalPolicy.vue' /* webpackChunkName: "pages/portal/user/customerService/privatePolicy/operationalPolicy/operationalPolicy" */))
const _1b0df472 = () => interopDefault(import('../../../pages/portal/user/customerService/privatePolicy/personalInformation/personalInformation.vue' /* webpackChunkName: "pages/portal/user/customerService/privatePolicy/personalInformation/personalInformation" */))
const _3b49b436 = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/allSchool/allSchool_edit.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/allSchool/allSchool_edit" */))
const _2c018cca = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/allSchool/allSchool_list.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/allSchool/allSchool_list" */))
const _0b231b3c = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/selectSchool/selectSchool_edit.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/selectSchool/selectSchool_edit" */))
const _29b36a14 = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/selectSchool/selectSchool_list.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/accountMgmt/userAccount/selectSchool/selectSchool_list" */))
const _52bc8764 = () => interopDefault(import('../../../pages/portal/manager/workspaceMgmt/organizationMgmt/authorityMgmt/staff_authority/staff_list.vue' /* webpackChunkName: "pages/portal/manager/workspaceMgmt/organizationMgmt/authorityMgmt/staff_authority/staff_list" */))
const _6dc1649c = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/curriculum/geniusCurriculum.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/curriculum/geniusCurriculum" */))
const _1c45a0fc = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/dataroom/geniusCenterDataroom_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/dataroom/geniusCenterDataroom_list" */))
const _1357cf83 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/dataroom/geniusCenterDataroom_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/dataroom/geniusCenterDataroom_view" */))
const _52c80eac = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/intro/centerIntro.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/intro/centerIntro" */))
const _711ec3f0 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/notice/geniusCenterBoard_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/notice/geniusCenterBoard_list" */))
const _6830f277 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/notice/geniusCenterBoard_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/notice/geniusCenterBoard_view" */))
const _2a8b16f0 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/online/online_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/online/online_list" */))
const _3c66b9e2 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/centerGenius/online/online_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/centerGenius/online/online_view" */))
const _684fc42d = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/eduGenius/dataroom/geniusBoard_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/eduGenius/dataroom/geniusBoard_list" */))
const _5f61f2b4 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/eduGenius/dataroom/geniusBoard_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/eduGenius/dataroom/geniusBoard_view" */))
const _a43e2898 = () => interopDefault(import('../../../pages/portal/user/eduActivities/InfoGenius/eduGenius/intro/eduIntro.vue' /* webpackChunkName: "pages/portal/user/eduActivities/InfoGenius/eduGenius/intro/eduIntro" */))
const _743dbd82 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduInformation/challenge/informationChallenge_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduInformation/challenge/informationChallenge_list" */))
const _86196074 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduInformation/challenge/informationChallenge_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduInformation/challenge/informationChallenge_view" */))
const _400f54c2 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduInformation/class/informationClass_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduInformation/class/informationClass_list" */))
const _51eaf7b4 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduInformation/class/informationClass_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduInformation/class/informationClass_view" */))
const _04d152d7 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduInformation/notice/informationBoard_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduInformation/notice/informationBoard_list" */))
const _0838fd44 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduInformation/notice/informationBoard_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduInformation/notice/informationBoard_view" */))
const _5daa0295 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/creativity/scienceCreativity_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/creativity/scienceCreativity_list" */))
const _54bc311c = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/creativity/scienceCreativity_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/creativity/scienceCreativity_view" */))
const _5ea0f532 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/exhibition/scienceExhibition_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/exhibition/scienceExhibition_list" */))
const _707c9824 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/exhibition/scienceExhibition_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/exhibition/scienceExhibition_view" */))
const _e95d189e = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/experience/scienceExperience_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/experience/scienceExperience_list" */))
const _fb38bb90 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/experience/scienceExperience_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/experience/scienceExperience_view" */))
const _73d839af = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/exploration/scienceExploration_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/exploration/scienceExploration_list" */))
const _6aea6836 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/exploration/scienceExploration_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/exploration/scienceExploration_view" */))
const _e1a71262 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/invention/scienceInvention_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/invention/scienceInvention_list" */))
const _f382b554 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/invention/scienceInvention_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/invention/scienceInvention_view" */))
const _3b67fd4a = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_edit.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_edit" */))
const _59f84c22 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_list" */))
const _6bd3ef14 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_view" */))
const _168771d7 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/notice/scienceBoard_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/notice/scienceBoard_list" */))
const _0d99a05e = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/notice/scienceBoard_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/notice/scienceBoard_view" */))
const _072a7691 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/olympics/scienceOlympics_list.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/olympics/scienceOlympics_list" */))
const _0386b5d0 = () => interopDefault(import('../../../pages/portal/user/eduActivities/scienceInfo/eduScience/olympics/scienceOlympics_view.vue' /* webpackChunkName: "pages/portal/user/eduActivities/scienceInfo/eduScience/olympics/scienceOlympics_view" */))
const _f8bc52e4 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/errors",
    component: _004d2fbc,
    name: "errors"
  }, {
    path: "/sample",
    component: _de7828be,
    name: "sample"
  }, {
    path: "/errors/errorPage",
    component: _1e7c8d87,
    name: "errors-errorPage"
  }, {
    path: "/errors/notFoundPage",
    component: _3461de7e,
    name: "errors-notFoundPage"
  }, {
    path: "/portal/search",
    component: _132e9f2a,
    name: "portal-search"
  }, {
    path: "/portal/youtubeTest",
    component: _b1b081ae,
    name: "portal-youtubeTest"
  }, {
    path: "/sample/calendar",
    component: _65301182,
    name: "sample-calendar"
  }, {
    path: "/sample/carousel",
    component: _0d5495b8,
    name: "sample-carousel"
  }, {
    path: "/sample/github",
    component: _f95703b2,
    name: "sample-github"
  }, {
    path: "/sample/rxjs_sample",
    component: _3f30bf2c,
    name: "sample-rxjs_sample"
  }, {
    path: "/portal/GwNoteDataBoxGuide/GwNoteDataBoxGuide",
    component: _53670fe0,
    name: "portal-GwNoteDataBoxGuide-GwNoteDataBoxGuide"
  }, {
    path: "/portal/joinGuide/ipCertifiedGuide",
    component: _ed6b93d0,
    name: "portal-joinGuide-ipCertifiedGuide"
  }, {
    path: "/portal/joinGuide/phoneCertifiedGuide",
    component: _2b69e852,
    name: "portal-joinGuide-phoneCertifiedGuide"
  }, {
    path: "/portal/mam/mam_list",
    component: _76a56db9,
    name: "portal-mam-mam_list"
  }, {
    path: "/portal/mam/mam_view",
    component: _6db79c40,
    name: "portal-mam-mam_view"
  }, {
    path: "/portal/popupImg/popup_img",
    component: _5ab77ed7,
    name: "portal-popupImg-popup_img"
  }, {
    path: "/portal/snsLogin/portal_sns",
    component: _74cc79f4,
    name: "portal-snsLogin-portal_sns"
  }, {
    path: "/portal/ssoLogin/portal_sso",
    component: _2955b3bc,
    name: "portal-ssoLogin-portal_sso"
  }, {
    path: "/portal/ssoLogin/portal_sso_eow",
    component: _b04f9b20,
    name: "portal-ssoLogin-portal_sso_eow"
  }, {
    path: "/sample/calendar/DateListModel",
    component: _7ceff1c2,
    name: "sample-calendar-DateListModel"
  }, {
    path: "/sample/calendar/DateModel",
    component: _6dbf93f8,
    name: "sample-calendar-DateModel"
  }, {
    path: "/sample/calendar/temp",
    component: _1c386a8a,
    name: "sample-calendar-temp"
  }, {
    path: "/sample/gDrive/googleDriveUploadSample",
    component: _221535de,
    name: "sample-gDrive-googleDriveUploadSample"
  }, {
    path: "/sample/google/callGoogleApiSample",
    component: _e3d3ad50,
    name: "sample-google-callGoogleApiSample"
  }, {
    path: "/portal/manager/iframeMgmt/managerIframe",
    component: _01bfb2c8,
    name: "portal-manager-iframeMgmt-managerIframe"
  }, {
    path: "/portal/manager/layout/TheManagerFooter",
    component: _774f048b,
    name: "portal-manager-layout-TheManagerFooter"
  }, {
    path: "/portal/manager/layout/TheManagerSideBar",
    component: _7e74a0fc,
    name: "portal-manager-layout-TheManagerSideBar"
  }, {
    path: "/portal/user/common/commonBoard_edit",
    component: _de785126,
    name: "portal-user-common-commonBoard_edit"
  }, {
    path: "/portal/user/common/commonBoard_list",
    component: _fd089ffe,
    name: "portal-user-common-commonBoard_list"
  }, {
    path: "/portal/user/common/commonBoard_view",
    component: _788dde88,
    name: "portal-user-common-commonBoard_view"
  }, {
    path: "/portal/user/common/commonForm",
    component: _0f0bb96e,
    name: "portal-user-common-commonForm"
  }, {
    path: "/portal/user/common/commonScreen",
    component: _b4bec6d4,
    name: "portal-user-common-commonScreen"
  }, {
    path: "/portal/user/eduTech/edu_tech",
    component: _21222197,
    name: "portal-user-eduTech-edu_tech"
  }, {
    path: "/portal/user/join/join_auth",
    component: _7c5cfe0d,
    name: "portal-user-join-join_auth"
  }, {
    path: "/portal/user/join/join_certificate",
    component: _0a3b9e42,
    name: "portal-user-join-join_certificate"
  }, {
    path: "/portal/user/join/join_main",
    component: _267db59e,
    name: "portal-user-join-join_main"
  }, {
    path: "/portal/user/join/join_proxy",
    component: _c31f644e,
    name: "portal-user-join-join_proxy"
  }, {
    path: "/portal/user/join/join_write",
    component: _66fcbaca,
    name: "portal-user-join-join_write"
  }, {
    path: "/portal/user/join/joinSupporter",
    component: _58b4e0ad,
    name: "portal-user-join-joinSupporter"
  }, {
    path: "/portal/user/landing/user_landing",
    component: _e48c1f20,
    name: "portal-user-landing-user_landing"
  }, {
    path: "/portal/user/login/user_login",
    component: _73cbbea0,
    name: "portal-user-login-user_login"
  }, {
    path: "/portal/user/login/user_pwd_edit",
    component: _3791fe56,
    name: "portal-user-login-user_pwd_edit"
  }, {
    path: "/portal/user/login/user_search_id",
    component: _c6eb5f4e,
    name: "portal-user-login-user_search_id"
  }, {
    path: "/portal/user/login/user_search_pw",
    component: _acf00976,
    name: "portal-user-login-user_search_pw"
  }, {
    path: "/portal/user/main/user_main",
    component: _3237e328,
    name: "portal-user-main-user_main"
  }, {
    path: "/portal/user/main/user_main_old",
    component: _0099edd4,
    name: "portal-user-main-user_main_old"
  }, {
    path: "/portal/user/main/user_main2",
    component: _14952f14,
    name: "portal-user-main-user_main2"
  }, {
    path: "/portal/user/search/search_main",
    component: _0444d3c4,
    name: "portal-user-search-search_main"
  }, {
    path: "/portal/user/sso/sso_account_mgnt",
    component: _c1c2a392,
    name: "portal-user-sso-sso_account_mgnt"
  }, {
    path: "/portal/user/sso/sso_login_eox",
    component: _2d478c03,
    name: "portal-user-sso-sso_login_eox"
  }, {
    path: "/portal/user/userWorkspace/manageMy_information",
    component: _00d302d8,
    name: "portal-user-userWorkspace-manageMy_information"
  }, {
    path: "/portal/user/userWorkspace/part_edit",
    component: _14506f68,
    name: "portal-user-userWorkspace-part_edit"
  }, {
    path: "/portal/user/userWorkspace/userMgmt_edit",
    component: _9410039a,
    name: "portal-user-userWorkspace-userMgmt_edit"
  }, {
    path: "/portal/user/userWorkspace/userMgmt_list",
    component: _b2a05272,
    name: "portal-user-userWorkspace-userMgmt_list"
  }, {
    path: "/portal/workspace/main/main",
    component: _393ffdb4,
    name: "portal-workspace-main-main"
  }, {
    path: "/portal/manager/homepageMgmt/history/history_list",
    component: _ef4a401a,
    name: "portal-manager-homepageMgmt-history-history_list"
  }, {
    path: "/portal/manager/homepageMgmt/mainTask/main_task_edit",
    component: _d310cfa0,
    name: "portal-manager-homepageMgmt-mainTask-main_task_edit"
  }, {
    path: "/portal/manager/homepageMgmt/mainTask/main_task_list",
    component: _f1a11e78,
    name: "portal-manager-homepageMgmt-mainTask-main_task_list"
  }, {
    path: "/portal/manager/homepageMgmt/managerSchedule/managerSchedule_board_view",
    component: _6874095a,
    name: "portal-manager-homepageMgmt-managerSchedule-managerSchedule_board_view"
  }, {
    path: "/portal/manager/homepageMgmt/managerSchedule/managerSchedule_list",
    component: _76993153,
    name: "portal-manager-homepageMgmt-managerSchedule-managerSchedule_list"
  }, {
    path: "/portal/manager/homepageMgmt/orgChart/orgChart_list",
    component: _30d7d29d,
    name: "portal-manager-homepageMgmt-orgChart-orgChart_list"
  }, {
    path: "/portal/manager/homepageMgmt/popup/popup_edit",
    component: _6152656f,
    name: "portal-manager-homepageMgmt-popup-popup_edit"
  }, {
    path: "/portal/manager/homepageMgmt/popup/popup_list",
    component: _520a3e03,
    name: "portal-manager-homepageMgmt-popup-popup_list"
  }, {
    path: "/portal/manager/homepageMgmt/youtube/youTube_list",
    component: _19ba8375,
    name: "portal-manager-homepageMgmt-youtube-youTube_list"
  }, {
    path: "/portal/manager/homepageMgmt/youtube/youTube_upload",
    component: _a044b8d0,
    name: "portal-manager-homepageMgmt-youtube-youTube_upload"
  }, {
    path: "/portal/manager/mamMgmt/appMgmt/app_edit",
    component: _2a71e4aa,
    name: "portal-manager-mamMgmt-appMgmt-app_edit"
  }, {
    path: "/portal/manager/mamMgmt/appMgmt/app_list",
    component: _49023382,
    name: "portal-manager-mamMgmt-appMgmt-app_list"
  }, {
    path: "/portal/manager/mamMgmt/domainMgmt/domain_edit",
    component: _175cf1de,
    name: "portal-manager-mamMgmt-domainMgmt-domain_edit"
  }, {
    path: "/portal/manager/mamMgmt/domainMgmt/domain_list",
    component: _35ed40b6,
    name: "portal-manager-mamMgmt-domainMgmt-domain_list"
  }, {
    path: "/portal/manager/onlinerequestMgmt/bulletinMgmt/bulletinMgmt_edit",
    component: _6c1ecc66,
    name: "portal-manager-onlinerequestMgmt-bulletinMgmt-bulletinMgmt_edit"
  }, {
    path: "/portal/manager/onlinerequestMgmt/bulletinMgmt/bulletinMgmt_list",
    component: _8aaf1b3e,
    name: "portal-manager-onlinerequestMgmt-bulletinMgmt-bulletinMgmt_list"
  }, {
    path: "/portal/manager/onlinerequestMgmt/statisticsMgmt/statisticsMgmt_list",
    component: _10168bbe,
    name: "portal-manager-onlinerequestMgmt-statisticsMgmt-statisticsMgmt_list"
  }, {
    path: "/portal/manager/onlinerequestMgmt/topicMgmt/topicMgmt_edit",
    component: _ab2ffdaa,
    name: "portal-manager-onlinerequestMgmt-topicMgmt-topicMgmt_edit"
  }, {
    path: "/portal/manager/onlinerequestMgmt/topicMgmt/topicMgmt_list",
    component: _c9c04c82,
    name: "portal-manager-onlinerequestMgmt-topicMgmt-topicMgmt_list"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/bannedWords/bannedWordsMgmt",
    component: _5fcb978a,
    name: "portal-manager-shorteningUrlMgmt-bannedWords-bannedWordsMgmt"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/manageDomainBlocking/manageDomainBlocking_edit",
    component: _71dffed2,
    name: "portal-manager-shorteningUrlMgmt-manageDomainBlocking-manageDomainBlocking_edit"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/manageDomainBlocking/manageDomainBlocking_list",
    component: _90704daa,
    name: "portal-manager-shorteningUrlMgmt-manageDomainBlocking-manageDomainBlocking_list"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/notice/notice_list",
    component: _73062e2b,
    name: "portal-manager-shorteningUrlMgmt-notice-notice_list"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/openUrlMgmt/openUrlMgmt_list",
    component: _5d3ed3dd,
    name: "portal-manager-shorteningUrlMgmt-openUrlMgmt-openUrlMgmt_list"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/urlCreationStatus/urlCreationStatus_edit",
    component: _fb1d4b56,
    name: "portal-manager-shorteningUrlMgmt-urlCreationStatus-urlCreationStatus_edit"
  }, {
    path: "/portal/manager/shorteningUrlMgmt/urlCreationStatus/urlCreationStatus_list",
    component: _732932e9,
    name: "portal-manager-shorteningUrlMgmt-urlCreationStatus-urlCreationStatus_list"
  }, {
    path: "/portal/user/adminActivate/bidInfo/bidInfo_list",
    component: _17d77a10,
    name: "portal-user-adminActivate-bidInfo-bidInfo_list"
  }, {
    path: "/portal/user/adminActivate/bidInfo/bidInfo_view",
    component: _29b31d02,
    name: "portal-user-adminActivate-bidInfo-bidInfo_view"
  }, {
    path: "/portal/user/adminActivate/notice/notice_list",
    component: _daa295e0,
    name: "portal-user-adminActivate-notice-notice_list"
  }, {
    path: "/portal/user/adminActivate/notice/notice_view",
    component: _ec7e38d2,
    name: "portal-user-adminActivate-notice-notice_view"
  }, {
    path: "/portal/user/adminActivate/openBudget/budget_list",
    component: _2be4a0cc,
    name: "portal-user-adminActivate-openBudget-budget_list"
  }, {
    path: "/portal/user/adminActivate/openBudget/budget_view",
    component: _3dc043be,
    name: "portal-user-adminActivate-openBudget-budget_view"
  }, {
    path: "/portal/user/adminActivate/openWorkcost/workcost_list",
    component: _414997fa,
    name: "portal-user-adminActivate-openWorkcost-workcost_list"
  }, {
    path: "/portal/user/adminActivate/openWorkcost/workcost_view",
    component: _385bc681,
    name: "portal-user-adminActivate-openWorkcost-workcost_view"
  }, {
    path: "/portal/user/adminActivate/publicData/publicData_list",
    component: _78910970,
    name: "portal-user-adminActivate-publicData-publicData_list"
  }, {
    path: "/portal/user/adminActivate/publicData/publicData_view",
    component: _6fa337f7,
    name: "portal-user-adminActivate-publicData-publicData_view"
  }, {
    path: "/portal/user/adminActivate/reportCenter/reportCenter_list",
    component: _243453b0,
    name: "portal-user-adminActivate-reportCenter-reportCenter_list"
  }, {
    path: "/portal/user/adminActivate/reportCenter/reportCenter_view",
    component: _1b468237,
    name: "portal-user-adminActivate-reportCenter-reportCenter_view"
  }, {
    path: "/portal/user/adminActivate/schedule/userSchedule_board_view",
    component: _55ea65e5,
    name: "portal-user-adminActivate-schedule-userSchedule_board_view"
  }, {
    path: "/portal/user/adminActivate/schedule/userSchedule_edit",
    component: _17f4ce5e,
    name: "portal-user-adminActivate-schedule-userSchedule_edit"
  }, {
    path: "/portal/user/adminActivate/schedule/userSchedule_list",
    component: _36851d36,
    name: "portal-user-adminActivate-schedule-userSchedule_list"
  }, {
    path: "/portal/user/centerGuide/basicDirection/basic_direction",
    component: _155d1ee6,
    name: "portal-user-centerGuide-basicDirection-basic_direction"
  }, {
    path: "/portal/user/centerGuide/centerNews/news_edit",
    component: _88eb6da8,
    name: "portal-user-centerGuide-centerNews-news_edit"
  }, {
    path: "/portal/user/centerGuide/centerNews/news_list",
    component: _a77bbc80,
    name: "portal-user-centerGuide-centerNews-news_list"
  }, {
    path: "/portal/user/centerGuide/centerNews/news_view",
    component: _b9575f72,
    name: "portal-user-centerGuide-centerNews-news_view"
  }, {
    path: "/portal/user/centerGuide/directions/center_directions",
    component: _0c4a0d80,
    name: "portal-user-centerGuide-directions-center_directions"
  }, {
    path: "/portal/user/centerGuide/facility/facility_info",
    component: _1320a14a,
    name: "portal-user-centerGuide-facility-facility_info"
  }, {
    path: "/portal/user/centerGuide/greeting/director_greeting",
    component: _9502949a,
    name: "portal-user-centerGuide-greeting-director_greeting"
  }, {
    path: "/portal/user/centerGuide/history/history_status",
    component: _5cb4a8d5,
    name: "portal-user-centerGuide-history-history_status"
  }, {
    path: "/portal/user/centerGuide/mainTask/main_task",
    component: _468bdbd7,
    name: "portal-user-centerGuide-mainTask-main_task"
  }, {
    path: "/portal/user/centerGuide/operationDirection/operation_direction",
    component: _08462ded,
    name: "portal-user-centerGuide-operationDirection-operation_direction"
  }, {
    path: "/portal/user/centerGuide/organization/organization_info",
    component: _defcb34a,
    name: "portal-user-centerGuide-organization-organization_info"
  }, {
    path: "/portal/user/customerService/browser/browserGuide",
    component: _1536e3b0,
    name: "portal-user-customerService-browser-browserGuide"
  }, {
    path: "/portal/user/customerService/copyright/copyrightProtect",
    component: _39550c06,
    name: "portal-user-customerService-copyright-copyrightProtect"
  }, {
    path: "/portal/user/customerService/email/refusalOfEmail",
    component: _4f085b6e,
    name: "portal-user-customerService-email-refusalOfEmail"
  }, {
    path: "/portal/user/eduResearch/contest/contest_edit",
    component: _08da1c23,
    name: "portal-user-eduResearch-contest-contest_edit"
  }, {
    path: "/portal/user/eduResearch/contest/contest_list",
    component: _0cdc1692,
    name: "portal-user-eduResearch-contest-contest_list"
  }, {
    path: "/portal/user/eduResearch/contest/contest_view",
    component: _1eb7b984,
    name: "portal-user-eduResearch-contest-contest_view"
  }, {
    path: "/portal/user/eduResearch/dataroom/dataroom_list",
    component: _508d7301,
    name: "portal-user-eduResearch-dataroom-dataroom_list"
  }, {
    path: "/portal/user/eduResearch/dataroom/dataroom_view",
    component: _479fa188,
    name: "portal-user-eduResearch-dataroom-dataroom_view"
  }, {
    path: "/portal/user/eduResearch/notice/research_edit",
    component: _9744172c,
    name: "portal-user-eduResearch-notice-research_edit"
  }, {
    path: "/portal/user/eduResearch/notice/research_list",
    component: _b5d46604,
    name: "portal-user-eduResearch-notice-research_list"
  }, {
    path: "/portal/user/eduResearch/notice/research_view",
    component: _c7b008f6,
    name: "portal-user-eduResearch-notice-research_view"
  }, {
    path: "/portal/user/eduResearch/school/edu_school",
    component: _1c54ebf5,
    name: "portal-user-eduResearch-school-edu_school"
  }, {
    path: "/portal/user/myPage/accessHistory/accessHistory_edit",
    component: _662203b2,
    name: "portal-user-myPage-accessHistory-accessHistory_edit"
  }, {
    path: "/portal/user/myPage/changePassword/changePassword_edit",
    component: _69e89e2e,
    name: "portal-user-myPage-changePassword-changePassword_edit"
  }, {
    path: "/portal/user/myPage/mobile/mobile_myPageInfo",
    component: _1c9a6da8,
    name: "portal-user-myPage-mobile-mobile_myPageInfo"
  }, {
    path: "/portal/user/myPage/personalInfo/personalInfo_edit",
    component: _f108d2ee,
    name: "portal-user-myPage-personalInfo-personalInfo_edit"
  }, {
    path: "/portal/user/myPage/snsInfo/snsInfo_edit",
    component: _1835d80a,
    name: "portal-user-myPage-snsInfo-snsInfo_edit"
  }, {
    path: "/portal/user/myPage/withdrawal/withdrawal_edit",
    component: _35869fae,
    name: "portal-user-myPage-withdrawal-withdrawal_edit"
  }, {
    path: "/portal/user/openInfo/infoList/infoList_edit",
    component: _11da26a8,
    name: "portal-user-openInfo-infoList-infoList_edit"
  }, {
    path: "/portal/user/openInfo/infoList/infoList_list",
    component: _306a7580,
    name: "portal-user-openInfo-infoList-infoList_list"
  }, {
    path: "/portal/user/openInfo/infoList/infoList_view",
    component: _42461872,
    name: "portal-user-openInfo-infoList-infoList_view"
  }, {
    path: "/portal/user/openInfo/preInfo/preInfo_edit",
    component: _17c3b2f0,
    name: "portal-user-openInfo-preInfo-preInfo_edit"
  }, {
    path: "/portal/user/openInfo/preInfo/preInfo_list",
    component: _365401c8,
    name: "portal-user-openInfo-preInfo-preInfo_list"
  }, {
    path: "/portal/user/openInfo/preInfo/preInfo_view",
    component: _482fa4ba,
    name: "portal-user-openInfo-preInfo-preInfo_view"
  }, {
    path: "/portal/user/sendSms/sendSmsPage/sendSmsPage",
    component: _6645370e,
    name: "portal-user-sendSms-sendSmsPage-sendSmsPage"
  }, {
    path: "/portal/manager/homepageMgmt/statistics/tchecked/tchecked_list",
    component: _f255b54a,
    name: "portal-manager-homepageMgmt-statistics-tchecked-tchecked_list"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/bannedWordsMgmt/bannedWordsMgmt_CommonList",
    component: _14e1952b,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-bannedWordsMgmt-bannedWordsMgmt_CommonList"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/bannedWordsMgmt/bannedWordsMgmt_list",
    component: _85281500,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-bannedWordsMgmt-bannedWordsMgmt_list"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/boardMgmt/boardMgmt_list",
    component: _ea1de46c,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-boardMgmt-boardMgmt_list"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/boardMgmt/boardMgmt_posting_list",
    component: _875f8bb2,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-boardMgmt-boardMgmt_posting_list"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/deletedPostingMgmt/deletedPostingMgmt_list",
    component: _6d9fee1a,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-deletedPostingMgmt-deletedPostingMgmt_list"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/deletedPostingMgmt/deletedPostingMgmt_posting_list",
    component: _4781ca77,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-deletedPostingMgmt-deletedPostingMgmt_posting_list"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/postingMgmt/postingMgmt_edit",
    component: _c0d41504,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-postingMgmt-postingMgmt_edit"
  }, {
    path: "/portal/manager/portalMgmt/integratedBoardMgmt/postingMgmt/postingMgmt_list",
    component: _df6463dc,
    name: "portal-manager-portalMgmt-integratedBoardMgmt-postingMgmt-postingMgmt_list"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/block/block_list",
    component: _1559a005,
    name: "portal-manager-portalMgmt-memberMgmt-block-block_list"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/dormant/dormant_list",
    component: _346fbbdd,
    name: "portal-manager-portalMgmt-memberMgmt-dormant-dormant_list"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/general/general_edit",
    component: _15eea87b,
    name: "portal-manager-portalMgmt-memberMgmt-general-general_edit"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/general/general_list",
    component: _06a6810f,
    name: "portal-manager-portalMgmt-memberMgmt-general-general_list"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/memberIp/ip_edit",
    component: _48327ab2,
    name: "portal-manager-portalMgmt-memberMgmt-memberIp-ip_edit"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/memberIp/ip_list",
    component: _66c2c98a,
    name: "portal-manager-portalMgmt-memberMgmt-memberIp-ip_list"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/permission/permission_classification",
    component: _8f2f3a6e,
    name: "portal-manager-portalMgmt-memberMgmt-permission-permission_classification"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/secession/secession_list",
    component: _110931b7,
    name: "portal-manager-portalMgmt-memberMgmt-secession-secession_list"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/staff/staff_edit",
    component: _818f306a,
    name: "portal-manager-portalMgmt-memberMgmt-staff-staff_edit"
  }, {
    path: "/portal/manager/portalMgmt/memberMgmt/staff/staff_list",
    component: _a01f7f42,
    name: "portal-manager-portalMgmt-memberMgmt-staff-staff_list"
  }, {
    path: "/portal/manager/portalMgmt/menuMgmt/menu/menu_Classification",
    component: _44adc5f8,
    name: "portal-manager-portalMgmt-menuMgmt-menu-menu_Classification"
  }, {
    path: "/portal/manager/portalMgmt/sendSmsMgmt/autoSendMail/mailTemplate_list",
    component: _ebd8ec0e,
    name: "portal-manager-portalMgmt-sendSmsMgmt-autoSendMail-mailTemplate_list"
  }, {
    path: "/portal/manager/portalMgmt/sendSmsMgmt/autoSendSms/autoSendSms",
    component: _733692d2,
    name: "portal-manager-portalMgmt-sendSmsMgmt-autoSendSms-autoSendSms"
  }, {
    path: "/portal/manager/portalMgmt/sendSmsMgmt/hist/sendHistList",
    component: _05305612,
    name: "portal-manager-portalMgmt-sendSmsMgmt-hist-sendHistList"
  }, {
    path: "/portal/manager/portalMgmt/sendSmsMgmt/sendMailHist/sendMailHist_list",
    component: _1f5332dc,
    name: "portal-manager-portalMgmt-sendSmsMgmt-sendMailHist-sendMailHist_list"
  }, {
    path: "/portal/manager/portalMgmt/sendSmsMgmt/sendSmsPage/sendSmsPage",
    component: _38258d5a,
    name: "portal-manager-portalMgmt-sendSmsMgmt-sendSmsPage-sendSmsPage"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/agencyCode/agency_edit",
    component: _3df66117,
    name: "portal-manager-portalMgmt-standardInformationMgmt-agencyCode-agency_edit"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/agencyCode/agency_list",
    component: _2eae39ab,
    name: "portal-manager-portalMgmt-standardInformationMgmt-agencyCode-agency_list"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/commonCode/common_edit",
    component: _6754b4d7,
    name: "portal-manager-portalMgmt-standardInformationMgmt-commonCode-common_edit"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/commonCode/common_list",
    component: _580c8d6b,
    name: "portal-manager-portalMgmt-standardInformationMgmt-commonCode-common_list"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/envConfig/env_config",
    component: _1a283038,
    name: "portal-manager-portalMgmt-standardInformationMgmt-envConfig-env_config"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/modutalk/modutalk_list",
    component: _297a495e,
    name: "portal-manager-portalMgmt-standardInformationMgmt-modutalk-modutalk_list"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/unassignedAgency/unassigned_agency_edit",
    component: _59e5336f,
    name: "portal-manager-portalMgmt-standardInformationMgmt-unassignedAgency-unassigned_agency_edit"
  }, {
    path: "/portal/manager/portalMgmt/standardInformationMgmt/unassignedAgency/unassigned_agency_list",
    component: _4a9d0c03,
    name: "portal-manager-portalMgmt-standardInformationMgmt-unassignedAgency-unassigned_agency_list"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_detail",
    component: _36aad106,
    name: "portal-manager-portalMgmt-statisticsMgmt-memberAccessStatusMgmt-accessStatus_detail"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_edit",
    component: _556ba57f,
    name: "portal-manager-portalMgmt-statisticsMgmt-memberAccessStatusMgmt-accessStatus_edit"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/memberAccessStatusMgmt/accessStatus_list",
    component: _46237e13,
    name: "portal-manager-portalMgmt-statisticsMgmt-memberAccessStatusMgmt-accessStatus_list"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_detail",
    component: _df0f2cfe,
    name: "portal-manager-portalMgmt-statisticsMgmt-membershipRegistration-registration_detail"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_edit",
    component: _bda9be8c,
    name: "portal-manager-portalMgmt-statisticsMgmt-membershipRegistration-registration_edit"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/membershipRegistration/registration_list",
    component: _dc3a0d64,
    name: "portal-manager-portalMgmt-statisticsMgmt-membershipRegistration-registration_list"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_detail",
    component: _2218427e,
    name: "portal-manager-portalMgmt-statisticsMgmt-membershipWithdrawalStatus-withdrawalStatus_detail"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_edit",
    component: _12fa340c,
    name: "portal-manager-portalMgmt-statisticsMgmt-membershipWithdrawalStatus-withdrawalStatus_edit"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/membershipWithdrawalStatus/withdrawalStatus_list",
    component: _318a82e4,
    name: "portal-manager-portalMgmt-statisticsMgmt-membershipWithdrawalStatus-withdrawalStatus_list"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/menuAccessStatistics/accessStatus_list",
    component: _43d28ee8,
    name: "portal-manager-portalMgmt-statisticsMgmt-menuAccessStatistics-accessStatus_list"
  }, {
    path: "/portal/manager/portalMgmt/statisticsMgmt/systemVisitStatus/visitStatus_list",
    component: _90e0e56a,
    name: "portal-manager-portalMgmt-statisticsMgmt-systemVisitStatus-visitStatus_list"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/auditGoogleUser/audit_google_user_list",
    component: _77094dca,
    name: "portal-manager-workspaceMgmt-accountMgmt-auditGoogleUser-audit_google_user_list"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/deleteAccount/delete_list",
    component: _5f2890fa,
    name: "portal-manager-workspaceMgmt-accountMgmt-deleteAccount-delete_list"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/userAccount/user_account",
    component: _8d630ffe,
    name: "portal-manager-workspaceMgmt-accountMgmt-userAccount-user_account"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/userAccount/user_account_delete",
    component: _57c6c2d9,
    name: "portal-manager-workspaceMgmt-accountMgmt-userAccount-user_account_delete"
  }, {
    path: "/portal/manager/workspaceMgmt/organizationMgmt/authorityMgmt/authority",
    component: _11e9e812,
    name: "portal-manager-workspaceMgmt-organizationMgmt-authorityMgmt-authority"
  }, {
    path: "/portal/manager/workspaceMgmt/organizationMgmt/schoolMgmt/school_list",
    component: _174a7440,
    name: "portal-manager-workspaceMgmt-organizationMgmt-schoolMgmt-school_list"
  }, {
    path: "/portal/user/adminActivate/dataroom/genAffairs/genAffairs_list",
    component: _631671c6,
    name: "portal-user-adminActivate-dataroom-genAffairs-genAffairs_list"
  }, {
    path: "/portal/user/adminActivate/dataroom/genAffairs/genAffairs_view",
    component: _5a28a04d,
    name: "portal-user-adminActivate-dataroom-genAffairs-genAffairs_view"
  }, {
    path: "/portal/user/adminActivate/dataroom/gwEdu/gwEdu_list",
    component: _9b8e7690,
    name: "portal-user-adminActivate-dataroom-gwEdu-gwEdu_list"
  }, {
    path: "/portal/user/adminActivate/dataroom/gwEdu/gwEdu_view",
    component: _ad6a1982,
    name: "portal-user-adminActivate-dataroom-gwEdu-gwEdu_view"
  }, {
    path: "/portal/user/adminActivate/dataroom/infoSupport/infoSupport_list",
    component: _35a88a02,
    name: "portal-user-adminActivate-dataroom-infoSupport-infoSupport_list"
  }, {
    path: "/portal/user/adminActivate/dataroom/infoSupport/infoSupport_view",
    component: _2cbab889,
    name: "portal-user-adminActivate-dataroom-infoSupport-infoSupport_view"
  }, {
    path: "/portal/user/adminActivate/dataroom/scienceEdu/scienceEdu_list",
    component: _077698c6,
    name: "portal-user-adminActivate-dataroom-scienceEdu-scienceEdu_list"
  }, {
    path: "/portal/user/adminActivate/dataroom/scienceEdu/scienceEdu_view",
    component: _02ee7166,
    name: "portal-user-adminActivate-dataroom-scienceEdu-scienceEdu_view"
  }, {
    path: "/portal/user/customerService/privatePolicy/operationalPolicy/operationalPolicy",
    component: _2d86983c,
    name: "portal-user-customerService-privatePolicy-operationalPolicy-operationalPolicy"
  }, {
    path: "/portal/user/customerService/privatePolicy/personalInformation/personalInformation",
    component: _1b0df472,
    name: "portal-user-customerService-privatePolicy-personalInformation-personalInformation"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/userAccount/allSchool/allSchool_edit",
    component: _3b49b436,
    name: "portal-manager-workspaceMgmt-accountMgmt-userAccount-allSchool-allSchool_edit"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/userAccount/allSchool/allSchool_list",
    component: _2c018cca,
    name: "portal-manager-workspaceMgmt-accountMgmt-userAccount-allSchool-allSchool_list"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/userAccount/selectSchool/selectSchool_edit",
    component: _0b231b3c,
    name: "portal-manager-workspaceMgmt-accountMgmt-userAccount-selectSchool-selectSchool_edit"
  }, {
    path: "/portal/manager/workspaceMgmt/accountMgmt/userAccount/selectSchool/selectSchool_list",
    component: _29b36a14,
    name: "portal-manager-workspaceMgmt-accountMgmt-userAccount-selectSchool-selectSchool_list"
  }, {
    path: "/portal/manager/workspaceMgmt/organizationMgmt/authorityMgmt/staff_authority/staff_list",
    component: _52bc8764,
    name: "portal-manager-workspaceMgmt-organizationMgmt-authorityMgmt-staff_authority-staff_list"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/curriculum/geniusCurriculum",
    component: _6dc1649c,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-curriculum-geniusCurriculum"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/dataroom/geniusCenterDataroom_list",
    component: _1c45a0fc,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-dataroom-geniusCenterDataroom_list"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/dataroom/geniusCenterDataroom_view",
    component: _1357cf83,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-dataroom-geniusCenterDataroom_view"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/intro/centerIntro",
    component: _52c80eac,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-intro-centerIntro"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/notice/geniusCenterBoard_list",
    component: _711ec3f0,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-notice-geniusCenterBoard_list"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/notice/geniusCenterBoard_view",
    component: _6830f277,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-notice-geniusCenterBoard_view"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/online/online_list",
    component: _2a8b16f0,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-online-online_list"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/centerGenius/online/online_view",
    component: _3c66b9e2,
    name: "portal-user-eduActivities-InfoGenius-centerGenius-online-online_view"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/eduGenius/dataroom/geniusBoard_list",
    component: _684fc42d,
    name: "portal-user-eduActivities-InfoGenius-eduGenius-dataroom-geniusBoard_list"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/eduGenius/dataroom/geniusBoard_view",
    component: _5f61f2b4,
    name: "portal-user-eduActivities-InfoGenius-eduGenius-dataroom-geniusBoard_view"
  }, {
    path: "/portal/user/eduActivities/InfoGenius/eduGenius/intro/eduIntro",
    component: _a43e2898,
    name: "portal-user-eduActivities-InfoGenius-eduGenius-intro-eduIntro"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduInformation/challenge/informationChallenge_list",
    component: _743dbd82,
    name: "portal-user-eduActivities-scienceInfo-eduInformation-challenge-informationChallenge_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduInformation/challenge/informationChallenge_view",
    component: _86196074,
    name: "portal-user-eduActivities-scienceInfo-eduInformation-challenge-informationChallenge_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduInformation/class/informationClass_list",
    component: _400f54c2,
    name: "portal-user-eduActivities-scienceInfo-eduInformation-class-informationClass_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduInformation/class/informationClass_view",
    component: _51eaf7b4,
    name: "portal-user-eduActivities-scienceInfo-eduInformation-class-informationClass_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduInformation/notice/informationBoard_list",
    component: _04d152d7,
    name: "portal-user-eduActivities-scienceInfo-eduInformation-notice-informationBoard_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduInformation/notice/informationBoard_view",
    component: _0838fd44,
    name: "portal-user-eduActivities-scienceInfo-eduInformation-notice-informationBoard_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/creativity/scienceCreativity_list",
    component: _5daa0295,
    name: "portal-user-eduActivities-scienceInfo-eduScience-creativity-scienceCreativity_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/creativity/scienceCreativity_view",
    component: _54bc311c,
    name: "portal-user-eduActivities-scienceInfo-eduScience-creativity-scienceCreativity_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/exhibition/scienceExhibition_list",
    component: _5ea0f532,
    name: "portal-user-eduActivities-scienceInfo-eduScience-exhibition-scienceExhibition_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/exhibition/scienceExhibition_view",
    component: _707c9824,
    name: "portal-user-eduActivities-scienceInfo-eduScience-exhibition-scienceExhibition_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/experience/scienceExperience_list",
    component: _e95d189e,
    name: "portal-user-eduActivities-scienceInfo-eduScience-experience-scienceExperience_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/experience/scienceExperience_view",
    component: _fb38bb90,
    name: "portal-user-eduActivities-scienceInfo-eduScience-experience-scienceExperience_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/exploration/scienceExploration_list",
    component: _73d839af,
    name: "portal-user-eduActivities-scienceInfo-eduScience-exploration-scienceExploration_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/exploration/scienceExploration_view",
    component: _6aea6836,
    name: "portal-user-eduActivities-scienceInfo-eduScience-exploration-scienceExploration_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/invention/scienceInvention_list",
    component: _e1a71262,
    name: "portal-user-eduActivities-scienceInfo-eduScience-invention-scienceInvention_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/invention/scienceInvention_view",
    component: _f382b554,
    name: "portal-user-eduActivities-scienceInfo-eduScience-invention-scienceInvention_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_edit",
    component: _3b67fd4a,
    name: "portal-user-eduActivities-scienceInfo-eduScience-lab-scienceLab_edit"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_list",
    component: _59f84c22,
    name: "portal-user-eduActivities-scienceInfo-eduScience-lab-scienceLab_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/lab/scienceLab_view",
    component: _6bd3ef14,
    name: "portal-user-eduActivities-scienceInfo-eduScience-lab-scienceLab_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/notice/scienceBoard_list",
    component: _168771d7,
    name: "portal-user-eduActivities-scienceInfo-eduScience-notice-scienceBoard_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/notice/scienceBoard_view",
    component: _0d99a05e,
    name: "portal-user-eduActivities-scienceInfo-eduScience-notice-scienceBoard_view"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/olympics/scienceOlympics_list",
    component: _072a7691,
    name: "portal-user-eduActivities-scienceInfo-eduScience-olympics-scienceOlympics_list"
  }, {
    path: "/portal/user/eduActivities/scienceInfo/eduScience/olympics/scienceOlympics_view",
    component: _0386b5d0,
    name: "portal-user-eduActivities-scienceInfo-eduScience-olympics-scienceOlympics_view"
  }, {
    path: "/",
    component: _f8bc52e4,
    name: "index"
  }, {
    path: "*",
    component: _3461de7e,
    name: "notFoundPage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
